import React from "react";
import GTMTracker from "../../utils/tracking/GTMTracker";

function navigateToAllShows() {
    GTMTracker.trackEngagement({
        bvpEventAction: "click",
        bvpEventLabel: "video.all_shows",
    });
}

function SeeAllShows() {
    return (
        <div className="see-all-shows">
            <a
                href="/live/schedule-shows"
                target="_blank"
                className="see-all-shows__link"
                onClick={navigateToAllShows}
            >
                See all shows
            </a>
        </div>
    );
}

export default SeeAllShows;
